import { Config } from "./constants/config.es6";
window.CONFIG = Config;

import ScrollFunc from "./modules/scrollfunc.es6";
import NewsList from "./features/news/newsList.es6";
import SplitFunc from "./modules/splitfunc.es6";
import Movie from "./ui/movie.es6";
import Parallax from "./modules/parallax.es6";
import ScrollNote from "./features/animation/scrollNote.es6";
import KeyVisual from "./features/top/keyvisual.es6";
import Slider from "./features/top/slider.es6";

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.scrollFunc = new ScrollFunc();
        this.KeyVisual = new KeyVisual();
        this.Slider = new Slider();
        this.newsList = new NewsList();
        this.splitFunc = new SplitFunc();
        this.movie = new Movie(this.scrollFunc);
        this.parallax = new Parallax();
        this.scrollNote = new ScrollNote();

        this.normalizeBgAnimation();
    }

    //背景アニメーションの可変幅を統一
    normalizeBgAnimation() {
        const targets = document.querySelectorAll(".js-bg");
        const targetHeight = 500; //すべての背景が同一px伸びるようにする

        targets.forEach((bg) => {
            const fullHeight = bg.parentElement.offsetHeight;
            const startScale = Math.max(0, (fullHeight - targetHeight) / fullHeight);

            //CSS変数にセット
            bg.style.setProperty("--start-scale", startScale);
        });
    }
}

new Main();
